import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from "vue";
import VuePageTitle from "vue-page-title";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NProgress from "vue-nprogress";
import Auth from "./services/auth";
import { $api, $EmailMonitoringApi, DBURL, parseError, initSentry, refreshToken } from "bh-mod";
import VueMq from "vue-mq";

initSentry(router);

import {
	Message,
	Button,
	Icon,
	Input,
	Form,
	Tooltip,
	Checkbox,
	notification,
	Divider,
	Col,
	Modal,
	message,
} from "ant-design-vue";

import "bh-mod/scss/global.scss";

var jwtDecode = require("jwt-decode");

Vue.use(VueMq, {
	breakpoints: {
		sm: 450,
		md: 1250,
		lg: Infinity,
	},
	defaultBreakpoint: "sm",
});

Vue.use(Modal);
Vue.use(Divider);
Vue.use(Col);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Input);
Vue.use(Form);
Vue.use(Tooltip);
Vue.use(Checkbox);
Vue.use(Message);

Vue.prototype.$bhapp = "superadmin";
Vue.prototype.$jwt = jwtDecode;
Vue.prototype.$notification = notification;
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$api = $api;
Vue.prototype.$EmailMonitoringApi = $EmailMonitoringApi;
Vue.prototype.$bh = DBURL;
Vue.prototype.$err = parseError
Vue.prototype.$userType = 'user'

Vue.use(NProgress);
Vue.use(Auth);
Vue.use(VuePageTitle, {
	prefix: "Bildhive | ",
	router,
});
Vue.config.devtools = true;
Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });

// Disable Vue Devtools in production
if (process.env.NODE_ENV === 'production') {
	Vue.config.devtools = false
}

(async () => {
	await refreshToken();
	new Vue({
		router,
		store,
		nprogress,
		render: (h) => h(App),
	}).$mount("#app");
})();
